import { Pipe, PipeTransform } from '@angular/core';

/**
 * What a privacy-deleted person is called wherever their content survives (kept photos, quotes,
 * feedback). Deliberately human and neutral rather than a status word like "DELETED" — hoteliers
 * see it on real story cards, so it has to read as a person, not an error state.
 *
 * Every surface that renders a deleted person's name must use this: story collection, story modal,
 * curation, submissions/winners, feedback cards.
 */
export const DELETED_PERSON_DISPLAY_NAME = 'Recent guest';

@Pipe({
    name: "fullName",
    standalone: false
})
export class FullNamePipe implements PipeTransform {
    transform(source: any, isInitialOnly: boolean = false) {
        if (!source) return '';
        if (isPiiDeleted(source)) return DELETED_PERSON_DISPLAY_NAME;
        if (!getFirstName(source) && !getLastName(source)) return fallbackName(source);
        return formatName(source, isInitialOnly);
    }
}

// A privacy-deleted person shows the replacement name instead of any residual PII.
export function isPiiDeleted(source) {
    return !!(source?.piiDeleteDate || source?.PiiDeleteDate || source?.pii_delete_date);
}


function getFirstName(source) {
    return source.first || source.FirstName || source.firstName;
}

function getLastName(source) {
    return source.last || source.LastName || source.lastName;
}

function formatName(source, isInitialOnly) {
    var name = getFirstName(source);
    if (getLastName(source)) name += ' ' + (isInitialOnly ? (getLastName(source).substring(0, 1) + ".") : getLastName(source));
    return name;
}

// Fallback display when no first/last name is present, so records identified
// only by other PII still render a meaningful label.
function fallbackName(source) {
    if (source.email || source.Email) return source.email || source.Email;
    if (source.crsNumber || source.crs_number) return 'CRS# ' + (source.crsNumber || source.crs_number);
    if (source.pmsNumber || source.pms_number) return 'PMS# ' + (source.pmsNumber || source.pms_number);
    return '';
}